import { Box, Container, Paper, Tab, Tabs } from '@mui/material';
import { AppState, emptySheet, labelEditorSlice } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { MainSimpleViewLoader } from '../../libraries/MainViewLoader';
import { appStore } from '../../store';
import { MasterViewPage } from '../MasterPage';
import { LabelEditor } from './labeleditor';
import { LabelerSheet } from './labelersheet';
import { NewPrintLabel } from './newprintjob';
import { XLSXImporter } from './xlsximporter';

/**
 * Composante qui permet de générer une série d'étiquettes à partir d'une source de données. 
 * Une sous-composante permet d'éditer le look des étiquettes.
 * Sources de données : Classeur Excel, csv, ou liste de la base de données.
 * 
 * Pour le moment, ça doit être standalone. Éventuellement, il faudra pouvoir sauvegarder le travail en cours, et sauvegarder des gabarits.
 * 
 * @returns Labeler view
 */

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export const Labeler = () => {

    React.useEffect(() => {

        const currentLabelData = localStorage.getItem('currentLabel');
        try {
            if (currentLabelData) {
                const label = JSON.parse(currentLabelData);
                if (label) {
                    appStore.dispatch(labelEditorSlice.actions.setCurrentPrintLabel(label));
                }
            }
        } catch {
            appStore.dispatch(labelEditorSlice.actions.setCurrentPrintLabel(undefined));
        }

        const currentSheetData = localStorage.getItem('currentSheet');
        try {
            if (currentSheetData) {
                const sheet = JSON.parse(currentSheetData);
                if (sheet) {
                    appStore.dispatch(labelEditorSlice.actions.setData(sheet));
                }
            }
        } catch {
            appStore.dispatch(labelEditorSlice.actions.setData({ ...emptySheet }));
        }
    }, []);


    return <MasterViewPage>
        <MainSimpleViewLoader
            path='labeler'>
            <LoadedLabeler />
        </MainSimpleViewLoader>
    </MasterViewPage>;
};

export const LoadedLabeler = () => {

    const currentTab = useSelector((state: AppState) => state.labelEditor.currentTab);
    const currentLabel = useSelector((state: AppState) => state.labelEditor.currentLabel);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        appStore.dispatch(labelEditorSlice.actions.setCurrentTab(newValue));
    };
    return <Container maxWidth={false}>
        <Paper>
            <Box sx={{ backgroundColor: 'white', borderBottom: 1, borderColor: 'divider' }}>
                <Tabs centered value={currentTab} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Données" />
                    <Tab label="Étiquette" />
                </Tabs>
            </Box>
            <CustomTabPanel value={currentTab} index={0}>
                <XLSXImporter />
                <LabelerSheet />
            </CustomTabPanel>
            <CustomTabPanel value={currentTab} index={1}>
                {currentLabel ? <LabelEditor /> : <NewPrintLabel />}
            </CustomTabPanel>
        </Paper>
    </Container>;

};
